<template>
  <div class="card">
    <div class="card-body">
      <div v-if="!readonly" class="cid-search">
        <InputSearchCid v-model="searchCid" @onSetSearchCid="addCid"/>
      </div>
      <div class="mb-6 table-container">
        <table class="table table-bordered table-hover table-light gy-3">
          <thead>
          <tr class="fw-bold fs-6 text-muted">
            <th class="text-center">CID</th>
            <th>Descrição</th>
            <th v-if="!readonly" class="text-center">Ações</th>
          </tr>
          </thead>
          <tr v-for="cid in cids" :key="cid.id_cid" class="cid-table-row">
            <td class="text-center">{{ cid.cid_code}}</td>
            <td>{{ cid.cid_name }}</td>
            <td v-if="!readonly" class="text-center">
              <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                      @click="delCid(cid.id_cid)"
                      title="Excluir CID">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../helpers/http";
import Alert from "../../../helpers/alert";
import InputSearchCid from "../../../components/InputSearchCid";

export default {
  name: "CidRequestItems",
  components: {
    InputSearchCid
  },
  props: {
    medicalRecord: Object,
    schedule: Object,
    readonly: false,
  },
  data() {
    return {
      cids: [],
      searchCid: '',
    }
  },
  mounted() {
    this.cids = this.medicalRecord.cids || [];
    if (this.schedule) {
      this.getCidRequestItems();
    }
  },
  methods: {
    clearCid() {
      this.searchCid = '';
    },
    getCidRequestItems() {
      http.get(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/cids`).then((response) => {
        this.cids = response.data;
      });
    },
    delCid(cidId) {
      http.delete(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/cids/${cidId}`).then(_ => {
        this.getCidRequestItems();
      }).catch(e => {
        Alert.toastError(e.response?.data?.message ?? e.response?.data ?? 'Não foi possível remover o CID.');
      });
    },
    addCid(cid) {
      if (!cid?.id_cid) {
        return;
      }
      if (this.cids.some((item) => item.id_cid === cid.id_cid)) {
        Alert.toastWarning('Este CID já está no prontuário.');
        this.clearCid();
        return;
      }

      http.post(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/cids`, { id_cid: cid.id_cid }).then(_ => {
        this.getCidRequestItems();
        this.clearCid();
      }).catch(e => {
        Alert.toastError(e.response?.data?.message ?? e.response?.data ?? 'Não foi possível adicionar o CID.');
      });
    }
  }
}
</script>

<style scoped>
.cid-search {
  margin-bottom: 16px;
}

.card {
  overflow: visible !important;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card-body {
  overflow: visible !important;
  max-height: none !important;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.table {
  overflow: visible !important;
  max-height: none !important;
  flex: 1;
}

.table-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.cid-table-row {
  font-size: 1.1rem;
}

.cid-table-row td {
  font-size: 1.1rem;
  padding: 0.75rem;
}
</style>
